export const resources = {
  SwitchDirectory: '',
  HeaderSignOut: ''
};
